import React, { createContext, useState, useContext, PropsWithChildren, RefObject } from 'react';

export type DealerListContextProps = {
  activeTab: number | undefined;
  setActiveTab: (tab: 'FAVORITES' | 'LOCATION') => void;

  searchOverlayRef?: RefObject<HTMLDivElement>;
  setSearchOverlayRef?: (ref: RefObject<HTMLDivElement>) => void;
};

const DealerListContext = createContext<DealerListContextProps | undefined>(undefined);

export const DealerListProvider: React.FC<PropsWithChildren<any>> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<number | undefined>(undefined);
  const [searchOverlayRef, setSearchOverlayRef] = useState<RefObject<HTMLDivElement>>(React.createRef());

  const setActiveTabHelper = (tab: string) => {
    switch (tab) {
      case 'FAVORITES':
        setActiveTab(0);
        break;
      case 'LOCATION':
        setActiveTab(1);
        break;
      default:
        setActiveTab(0);
        break;
    }
  };

  return (
    <DealerListContext.Provider value={{ activeTab, setActiveTab: setActiveTabHelper, searchOverlayRef, setSearchOverlayRef }}>
      {children}
    </DealerListContext.Provider>
  );
};

export const useDealerListContext = () => {
  const context = useContext(DealerListContext);

  if (!context) {
    throw new Error('useDealerListContext must be used within a DealerListProvider');
  }

  return context;
};
